import { render, staticRenderFns } from "./I18nEdit.vue?vue&type=template&id=4193a8e9&scoped=true&"
import script from "./I18nEdit.vue?vue&type=script&lang=js&"
export * from "./I18nEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4193a8e9",
  null
  
)

export default component.exports